import React from 'react'
import { LoadingPlaceholder } from '@mobi/component-library/Misc/LoadingPlaceholder'
import { List, ListItem } from '@mobi/component-library/Base/List'
import { Flex } from '@mobi/component-library/Misc/Flex'
import { radius, spacing } from '@mobi/component-library/Foundations'

export const LoadingSkeleton: React.FC = () => {
  return (
    <div data-testid='search-loading'>
      <List variant='card' itemSize='small'>
        {Array(10)
          .fill(null)
          .map((_, i) => (
            <ListItem
              key={i}
              content={
                <Flex flexDirection='row' gap={spacing.sm}>
                  <Flex flexDirection='column' gap='0.25rem'>
                    <LoadingPlaceholder width='2.5rem' height='2.5rem' borderRadius={radius.full} />
                  </Flex>

                  <Flex flexDirection='column' gap={spacing.smx1}>
                    <LoadingPlaceholder width='17rem' height='1rem' borderRadius={radius.lg} />
                    <LoadingPlaceholder width='26rem' height='0.7rem' borderRadius={radius.lg} />
                  </Flex>
                </Flex>
              }
            />
          ))}
      </List>
    </div>
  )
}
